import React from 'react'
import Layout from '@components/Layout'
import { Alert, Button } from '@mui/material'
import { Link } from 'react-router'

const NotFound = () => {
  return (
    <Layout pageName=''>
      <Alert severity="error">
        Страница не найдена
      </Alert>
      <Button component={Link} to='/' variant='text' color='info' sx={{ mt: 2 }}>
        Перейти на главную
      </Button>
    </Layout>
  )
}

export default NotFound